<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [noBow]="true"
      [canGoBack]="true"
      [title]="'Add Report'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />
    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-select
              [label]="'Report Type'"
              [items]="reportTypeItems"
              [form]="form.controls.reportType"
              [icon]="'assets/svg/information-circle.svg'"
              formControlName="reportType"
              [submitted]="submitted"
              [errorMessage]="'Please select a report type.'"
              (optionChange)="populateReportName($event)" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Report Name'"
              [icon]="'assets/svg/information-circle.svg'"
              formControlName="reportName"
              [form]="form.controls.reportName"
              [submitted]="submitted"
              [errorMessage]="'Please enter a name for this report.'" />
          </tidy-row>
        </form>
      </tidy-card>
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-button
        [action]="boundAddReport"
        [text]="'Next'"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
